<template>
    <b-modal
        id="modal-markrepair"
        ref="modal"
        :title="$t('com_cheesemark', { ns: 'common' })"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
    >
        <b-card @submit.stop.prevent="handleSubmit">
            <b-alert
                v-model="showDismissibleAlert"
                variant="danger"
                dismissible
            >
                {{ alertText }}
            </b-alert>
            <div
                class="form-inline"
                v-for="(ucm, index) in ucmList"
                v-bind:key="index"
            >
                <b-col sm="12" class="mx-0 px-0 my-1 py-0">
                    <merken-combo
                        v-bind:key="index"
                        v-model="ucmList[index]"
                        :editAllowed="editAllowed"
                        :cheeseProductID="ucm.productID"
                        :showButtons="false"
                        @change="setChanged"
                        @input="setChanged"
                    />
                </b-col>
            </div>
        </b-card>
    </b-modal>
</template>

<script>
import { CheeseMarks } from '@/models/BakInfo';
import { MerkenCombo } from '../components';
import { loadItem } from '@/models/DataHelper';
export default {
    name: 'RepairMarkModal',
    data: function () {
        return {
            showDismissibleAlert: false,
            alertText: '',
            merkaantal: 0,
            ucmList: [],
            isChanged: false,
            editAllowed: true
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        bakID: {
            type: Number,
            required: true
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    components: { MerkenCombo },
    watch: {},
    computed: {},
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide() {
            this.$emit('hide');
        },
        setChanged() {
            this.isChanged = true;
        },
        async checkFormValidity() {
            const invalidBasis = this.isChanged  ? '' : '';
            if (invalidBasis) this.showAlert(invalidBasis);
            const valid = !invalidBasis;
            return valid;
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        async handleSubmit() {
            // Exit when the form isn't valid
            if ((await this.checkFormValidity())==false) {
                return;
            }
            if (this.isChanged) this.saveThis();
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-markrepair');
            });
        },
        async saveThis() {
            const listCheeseMark = [];
            for(let i=0; i<this.ucmList.length; i++) {
                const CheeseMark ={
                    StartLetter: this.ucmList[i].startLetter,
                    StartNumber: this.ucmList[i].startNummer,
                    EndLetter: this.ucmList[i].eindLetter,
                    EndNumber: this.ucmList[i].eindNummer,
                    ShapeID: this.ucmList[i].vormID,
                    ProductID: this.ucmList[i].productID,}
                    listCheeseMark.push(CheeseMark);
            }
            const RepairCheeseMarksModel = {
                batchID: this.bakID,
                CheeseMarks: listCheeseMark
            };
            await loadItem(
                'production/repairCheeseMarksForBatch',
                RepairCheeseMarksModel,
                this.$t
            );
        }
    },
    mounted() {},
    async created() {
        const o = { batchID: this.bakID };
        const merken = await loadItem(
            'production/loadCheeseMarksForBatch',
            o,
            this.$t
        );
        this.ucmList = merken?.subSeries ?? [];
    }
};
</script>

<style scoped></style>
